<template>
  <b-dropdown
    v-if="visible && reporteDataId"
    size="sm"
    variant="light"
    toggle-class="btn icon-btn btn-sm btn-default"
    no-caret
    right
    class="ml-1"
  >
    <template #button-content>
      <i class="fa fa-pen"></i>
    </template>
    <b-dropdown-item :href="urlOrigen" target="_blank" rel="noopener noreferrer">
      <i class="fa fa-database mr-2"></i> Origen de datos
    </b-dropdown-item>
    <b-dropdown-item :href="urlApariencia" target="_blank" rel="noopener noreferrer">
      <i class="fa fa-eye mr-2"></i> Apariencia
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "DashboardEditMenu",
  props: {
    reporteDataId: {
      type: [Number, String],
    },
  },
  computed: {
    visible: function() {
      try {
        return (window.localStorage.getItem("EDIT-DASHBOARD") || "").toUpperCase() === "TRUE";
      } catch (e) {
        return false;
      }
    },
    urlOrigen: function() {
      return this.urlRuta("reports-data-edit");
    },
    urlApariencia: function() {
      return this.urlRuta("reports-data-view");
    },
  },
  methods: {
    urlRuta: function(name) {
      if (!this.reporteDataId) return "#";
      var ruta = this.$router.resolve({
        name: name,
        params: { reporteDataId: String(this.reporteDataId) },
      });
      return ruta && ruta.href ? ruta.href : "#";
    },
  },
};
</script>
